import { render } from "./CompanyTypeDetailsUpdate.vue?vue&type=template&id=293912f2"
import script from "./CompanyTypeDetailsUpdate.vue?vue&type=script&lang=js"
export * from "./CompanyTypeDetailsUpdate.vue?vue&type=script&lang=js"

import exportComponent from "C:\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Controller\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__